<template lang="pug">
  #change-customer-info
    b-card(header-tag="header")
      change-customer-data
</template>

<script>
import ChangeCustomerData from "@/components/supportSite/ChangeCustomerData";

export default {
  name: "ChangeCustomerInfo",
  components: {
    ChangeCustomerData,
  },
}
</script>

<style scoped>

</style>